<template>
	<div class="content">
		<div class="nav flex-c-s">
			<div class="logo_box flex-c-s">
				<img src="../assets/logo.png" mode=""></img>
				<text class="logo_word">Allcardplus</text>
			</div>
			<div class="tabs flex-c-s">
				<a class="tab hover" :href="'#'+item.value" @click="toPart(item,index)"
					:class="[{'active':tabIndex==index},{'center':index==1}]" v-for="(item,index) in tabList "
					:key="index">
					{{item.label}}
					<div class="line">

					</div>
				</a>

			</div>
			<!-- <div class="downLoad flex-c-s">
				<div @click="toDwon('android')" class="android hover flex-c-s">
					<img src="../assets/android.png" class="android_icon" mode=""></img>
					Android APP
				</div>
				<div @click="toDwon('ios')" class="ios hover flex-c-s">
					<img src="../assets/ios.png" class="ios_icon" mode=""></img>
					IOS APP
				</div>
			</div> -->
		</div>
		<div id="home" class="flex-c-b">
			<div class="cardTips">
				<div class="title">
					Best App
				</div>
				<div class="toSell flex-c-s">
					to
					<div class="sellCont flex-c-c">
						sell gift card.
					</div>
				</div>
				<div class="wordf">
					on <text class="right">Allcardplus</text>
				</div>
				<div class="tips">
					digital payments make everything <br>within reach
				</div>
				<!-- <view @click="toH5" class="toH5">
					Start Trading
				</view> -->

			</div>
			<img src="../assets/bg1.png" loading="lazy" class="bgf" alt="">
		</div>
		<div id="giftCards" class="flex-s-b">
			<div class="logo_box flex-s-s">
				<img src="../assets/logo2.png" mode=""></img>
				<text class="logo_word">Allcardplus</text>
			</div>
			<img src="../assets/bg2.png" loading="lazy" class="bgT" alt="">
			<div class="cont2">
				<div class="title">
					YOU CAN FIND ANY <br> CARD YOU WANT HERE
				</div>
				<div class="promise">
					We promise to
				</div>
				<div class="times flex-c-b">
					<div v-for="(item,index) in timeList" ::key="index" class="part">
						<div class="num">{{item.num}}</div>
						<div class="time">{{item.time}}</div>
					</div>
				</div>
			</div>

		</div>
		<div id="aboutUs">
			<div class="title">
				A TRUSTWORTHY COMPANY FOR <br>GIFT CARD TRANSACTIONS
			</div>
			<div class="p" style="color: #fff;">

				<img src="../assets/phone.png" alt="">

				<div style="color: #fff;" class="value">
					+852 68513201
				</div>
			</div>
			<div class="p" style="color: #fff;">

				<img src="../assets/mail.png" alt="">

				<div class="value">
					Allcardplus@gmail.com
				</div>
			</div>
			<div class="p" style="color: #fff;">

				<img style="height: 0.16rem;" src="../assets/vec.png" alt="">

				<div class="value">
					ALLCard Technology (HK) Limited
				</div>
			</div>
			<div class="p" style="color: #fff;">

				<img style="width: 0.22rem;height: 0.22rem;" src="../assets/adr.png" alt="">

				<div class="value">
					Room D07, 8/F, Kai Tak Factory Building Phase II, 99 King Fook Street,<br> San Po Kong, Hong Kong
				</div>
			</div>
			<div class="UP">
				<div @click="toUP(0)" class="userAm hover">
					User Agreement
				</div>
				<div @click="toUP(1)" class="pp hover">
					Privacy Policy
				</div>
			</div>
			<img src="../assets/bg3.png" loading="lazy" class="bg3" alt="">
		</div>
		<!-- <div class="footer_disclaimer" :style="{padding: `${30*scaleRate}px 5%`}">
			<p style="white-space: normal; word-wrap: break-word; text-align: center;">All
				brand names, trademarks, and logos are the property of their respective owners. This site is an
				independent gift card exchange and is not affiliated with, endorsed by, sponsored by, or authorized by
				Apple, Google, Amazon, or any other gift card issuer or brand.</p>
			<div class="toIs">
				<div @click="toInst(item)" v-for="(item,index) in instList" :key="index" class="instBtn">
					{{item.name}}
				</div>
			</div>
		</div> -->
	</div>
</template>

<script setup>
	import {
		ref,
		reactive
	} from 'vue'
	const timeList = ref([
		{ num: 7, time: '7 day a week' },
		{ num: 24, time: '24 hours a day' },
		{ num: 36, time: '365 days a year' }
	])
	const tabList = ref([{
		label: 'Home',
		value: 'home'
	}, {
		label: 'Gift Cards',
		value: 'giftCards'
	}, {
		label: 'About Us',
		value: 'aboutUs'
	}])
	const tabIndex = ref(0)
	const toPart = (item, index) => {
		tabIndex.value = index
	}
	const instList = ref([{
		name: 'About',
		url: 'https://allcardplus.com/agreement/aboutus.html'
	}, {
		name: 'Contact',
		url: 'https://allcardplus.com/agreement/why.html'
	}, {
		name: 'Terms',
		url: 'https://allcardplus.com/agreement/useragreement.html'
	}, {
		name: 'Privacy',
		url: 'https://allcardplus.com/agreement/privacypolicy.html'
	}, {
		name: 'KYC/AML',
		url: 'https://allcardplus.com/agreement/kyc.html'
	}])
	const toInst = (item) => {
		window.open(item.url)
	}
	const toUP = (val) => {
		window.location.href = val === 1 ? 'https://allcardplus.com/agreement/privacypolicy.html' : 'https://allcardplus.com/agreement/useragreement.html'
	}
	const toDwon = (val) => {
		const url = val === 'android' ? 'https://play.google.com/store/apps/details?id=com.product.allcard' : 'https://apps.apple.com/us/app/allcard/id6745785471'
		window.open(url)
	}
	const toH5 = () => {
		window.open('https://m.allcardplus.com/#/')
	}
</script>

<style>
	.logo_box {
		img {
			width: 0.44rem;
			height: 0.35rem;
		}

		.logo_word {
			margin-left: 0.1rem;
			color: #FDC500;
			font-feature-settings: 'liga' off, 'clig' off;
			font-family: "Racing Sans One";
			font-size: 0.22rem;
			font-weight: 400;
		}
	}

	.content {
		width: 100vw;
		padding-top: 0.84rem;

		.nav {
			position: fixed;
			top: 0;
			width: 100vw;
			height: 0.84rem;
			background: #434343;
			box-shadow: 0px 0.04rem 0.04rem 0px rgba(0, 0, 0, 0.05);
			z-index: 999;

			.logo_box {
				margin-left: 1.04rem;
			}

			.tabs {
				margin-left: 0.7rem;

				.tab {
					color: #FFF;
					font-family: Poppins;
					font-size: 0.16rem;
					font-style: normal;
					font-weight: 500;
					position: relative;
					flex-shrink: 0;
				}

				.center {
					margin: 0 0.61rem 0 0.49rem;
				}

				.active {
					color: #FDC500;

					.line {
						position: absolute;
						width: 60%;
						left: 50%;
						transform: translateX(-50%);
						height: 0.01rem;
						background: #FDC500;
					}
				}
			}

			.downLoad {
				margin-left: 3.56rem;

				.android,
				.ios {
					width: 1.4rem;
					height: 0.4rem;
					border-radius: 0.08rem;
					box-shadow: 0px 0.04rem 0.08rem 0px rgba(0, 0, 0, 0.08);
					font-weight: 500;
					font-family: ff500;
					font-size: 0.14rem;
				}

				.android {
					background: linear-gradient(310deg, #0046F6 22.91%, #00D9FF 80.32%);
					color: #fff;

					.android_icon {
						width: 0.21rem;
						height: 0.2rem;
						margin: 0 0.1042rem 0 0.09rem;
					}
				}

				.ios {
					margin-left: 0.21rem;
					background: linear-gradient(270deg, #1E9600 0.77%, #43E65E 99.02%);
					color: #333;

					.ios_icon {
						width: 0.18rem;
						height: 0.2rem;
						margin: 0 0.14rem 0 0.19rem;
					}
				}




			}
		}

		#home {
			width: 100vw;
			background: linear-gradient(180deg, #5A93FE 0%, #2A74FF 100%);

			.bgf {
				width: 7rem;
				height: 4.54rem;
				margin: 0.73rem 0.53rem 0.73rem 0;
				flex-shrink: 0;
			}

			.cardTips {
				margin-left: 1.34rem;

				div {
					display: flex;
				}

				.title {
					text-align: left;
					color: #FDC500;
					font-size: 0.8rem;
					font-weight: 900;
					font-family: ff800;
					letter-spacing: 0.04rem;
					text-shadow: 0.02rem 0.04rem 0.04rem rgba(0, 0, 0, 0.25);
					/* margin-top: 0.58rem; */
				}

				.toSell {
					color: #FFF;
					font-size: 0.4rem;
					font-weight: 700;
					font-family: ff500;

					.sellCont {
						padding: 0 0.1rem;
						height: 0.53rem;
						color: #5483F7;
						background: #fff;
						line-height: 0.53rem;
						border-radius: 0.2rem;
					}
				}

				.wordf {
					display: flex;
					align-items: baseline;
					color: #FFF;
					font-size: 0.4rem;
					font-weight: 700;
					font-family: ff500;
					margin-top: 0.17rem;

					.right {
						color: #FDC500;
						font-size: 0.48rem;
						margin-left: 0.1rem;
					}
				}

				.tips {
					color: #F6F6F6;
					font-size: 0.26rem;
					font-family: ff400;
					font-weight: 400;
					margin: 0.17rem 0 0.34rem 0;
					text-align: left;
				}

				.downLoad {
					margin-bottom: 0.31rem;

					.android {
						width: 2.04rem;
						height: 0.56rem;
						border-radius: 0.08rem;
						background: #57B560;
						color: #FFF;
						font-size: 0.18rem;
						font-family: ff500;
						font-weight: 500;

						.android_icon {
							width: 0.3rem;
							height: 0.31rem;
							margin: 0 0.14rem 0 0.2rem;
						}

					}

					.ios {
						width: 2.04rem;
						height: 0.56rem;
						border-radius: 0.08rem;
						background: #fff;
						color: #333;
						font-size: 0.18rem;
						font-family: ff500;
						font-weight: 500;
						margin-left: 0.4rem;

						.ios_icon {
							width: 0.26rem;
							height: 0.31rem;
							margin: 0 0.186rem 0 0.3rem;
						}

					}
				}
			}


		}

		#giftCards {
			position: relative;
			background: linear-gradient(180deg, #6A6A68 0%, #404040 100%);

			.logo_box {
				position: absolute;
				top: 0.65rem;
				left: 0.76rem;
			}

			.bgT {
				width: 6.92rem;
				height: 5.02rem;
				margin-left: 0.32rem;
				margin-top: 1.47rem;

			}

			.cont2 {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				position: absolute;
				left: 6.66rem;
			}

			.title {
				font-size: 0.6rem;
				font-family: ff800;
				font-weight: 900;
				line-height: 0.82rem;
				margin-top: 1rem;
				margin-right: 0.53rem;
				color: #FFC657;
			}

			.promise {
				min-width: 2.28rem;
				display: inline-block;
				background: #F8BB45;
				height: 0.5rem;
				line-height: 0.5rem;
				font-size: 0.4rem;
				font-family: ff800;
				font-weight: 800;
				margin: 0.37rem 0 0.84rem 0;
				padding-right: 0.2rem;
			}

			.times {
				width: 100%;
				padding: 0 0.7rem;
				box-sizing: border-box;
				margin-bottom: 1.44rem;

				.part {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;

					.num {
						color: #F8BB45;
						line-height: 0.48rem;
						font-family: ff800;
						font-size: 0.4rem;
						font-weight: 800;
					}

					.time {
						height: 0.24rem;
						font-size: 0.16rem;
						font-weight: 400;
						font-family: ff400;
						color: #F8BB45;
					}
				}
			}
		}
	}

	::-webkit-scrollbar {
		display: none;
	}

	a {
		text-decoration: none;
	}

	#aboutUs {
		position: relative;
		display: flex;
		flex-direction: column;
		background: linear-gradient(180deg, #FFC657 0%, #F0AF31 100%);
		width: 100%;
		padding-left: 1.38rem;
		box-sizing: border-box;

		.title {
			color: #141416;
			font-size: 0.4rem;
			line-height: 0.6rem;
			margin-top: 0.85rem;
		}

		.p {
			margin-top: 0.25rem;
			display: flex;
			align-items: center;

			img {
				width: 0.24rem;
				height: auto;
			}

			.value {
				font-weight: 500;
				font-size: 0.16rem;
				color: #51555E;
				height: 0.24rem;
				line-height: 0.24rem;
				margin-left: 0.3rem;

			}
		}

		.UP {
			margin-bottom: 0.6rem;

			div {
				display: inline-block;
				color: #FDC500;
				font-size: 0.2rem;
				font-weight: 400;
				font-family: ff400;
				line-height: 0.27rem;
				padding: 0.11rem 0.43rem;
				border-radius: 0.25rem;
				border: 1px solid #DAD9E2;
				background: #FEFFFF;
			}

			.pp {
				margin-left: 0.4rem;
			}
		}

		.bg3 {
			position: absolute;
			width: 6.64rem;
			height: 4.89rem;
			left: 7.61rem;
			top: 0.8rem;
		}
	}

	.toH5 {
		width: 1.78rem;
		height: 0.39rem;
		background: #FFFFFF;
		border-radius: 0.19rem;
		border: 1px solid #FFFFFF;
		font-family: ff600;
		font-weight: bold;
		font-size: 0.18rem;
		color: #5483F7;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

	}

	.footer_disclaimer {
		background: #434343;
		display: flex;
		flex-direction: column;

		.toIs {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 0.23rem;

			.instBtn {
				font-family: ff400;
				font-weight: 400;
				font-size: 0.09rem;
				color: #F8EAC7;
				line-height: 0.26rem;
				padding: 0 0.6rem;
				border-right: 1rpx solid #DCDCDC;
				cursor: pointer;
			}

			.instBtn:last-child {
				border-right: none;
			}
		}

		p {
			color: #fff;
			font-family: ff400;
			font-size: 0.12rem;
			font-style: normal;
			font-weight: 400;
			line-height: 0.2rem;
			width:8.25rem;
			margin:0.23rem  auto 0.08rem auto;
		}
	}
</style>